// ══════════════════════════════════════════════════════
//  DATOS DEL TITULAR Y DE LOS TEXTOS LEGALES
//  Único sitio con estos datos: los usan el aviso legal, la privacidad, las cookies,
//  los términos, el registro, el formulario de contacto y el pie de página.
//  Para cambiarlos, solo aquí.
//
//  Si algún dato vuelve a empezar por «PENDIENTE», es un marcador y no un dato real:
//  las páginas legales enseñan un aviso de «Borrador» hasta que se sustituya.
//  Sin NIF ni domicilio a propósito: la web es un proyecto personal sin ingresos (no es
//  actividad económica), así que solo se muestran el nombre y el email de contacto.
//  Los datos que había en la antigua Politica.jsx (otro nombre, otro NIF) no se han
//  reutilizado porque no consta que sean los del titular actual.
// ══════════════════════════════════════════════════════

export const PENDIENTE = "PENDIENTE";

export const TITULAR = {
  // Nombre y apellidos o razón social
  nombre: "Santiago Correa",
  // Email de contacto y para ejercer los derechos de protección de datos
  email: "goodappetiteadepartament@gmail.com",
  // Dominio de producción (sin https://)
  dominio: "platotrasplato.es",
  url: "https://platotrasplato.es",
  web: "Plato tras Plato",
};

// true si todavía quedan marcadores sin rellenar (el aviso legal y la privacidad lo avisan en pantalla)
export const DATOS_SIN_RELLENAR = Object.values(TITULAR).some((v) => String(v).includes(PENDIENTE));

// Fecha que se muestra en todas las páginas legales
export const FECHA_ACTUALIZACION = "17 de octubre de 2026";

// Versión de los términos y la privacidad que acepta quien se registra. Se guarda en la
// cuenta (aceptacionLegal.version). Si se cambian los textos de forma sustancial, poner
// la nueva fecha aquí Y en la API (Api-goodappetite/src/utils/legal.js → VERSIONES_LEGALES).
export const VERSION_LEGAL = "2026-10-17";

// Edad mínima para crear una cuenta (en España, el consentimiento propio parte de los 14 años)
export const EDAD_MINIMA = 14;

// Páginas legales (pie de página y enlaces cruzados entre ellas)
export const PAGINAS_LEGALES = [
  { ruta: "/aviso-legal", titulo: "Aviso legal" },
  { ruta: "/privacidad", titulo: "Política de privacidad" },
  { ruta: "/cookies", titulo: "Política de cookies" },
  { ruta: "/terminos", titulo: "Términos y condiciones" },
];
